import { FC } from 'react'
import cx from 'classnames'

import UrpsFact, { UrpsFactProps } from '../../UrpsFact'

import * as SC from './styled'

export type BlockUrpsFactsProps = {
  className?: string
  title: string
  items: Array<UrpsFactProps>
}

const BlockUrpsFacts: FC<BlockUrpsFactsProps> = ({
  className,
  title,
  items,
}) => {
  return (
    <SC.BlockUrpsFacts className={cx('BlockUrpsFacts', className)}>
      <SC.Title>{title}</SC.Title>
      <SC.FactList>
        {items.map((item, index) => (
          <SC.FactListItem key={index}>
            <UrpsFact {...item} />
          </SC.FactListItem>
        ))}
      </SC.FactList>
    </SC.BlockUrpsFacts>
  )
}

export default BlockUrpsFacts
